"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var common_hooks_1 = require("@l2p/common-hooks");
var Dropdown = function (_a) {
    var _b;
    var closeProfileDropdown = _a.closeProfileDropdown;
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var config = (0, swr_hooks_1.useConfig)();
    var openReferralWidget = (0, common_hooks_1.useOpenReferralWidget)();
    var signOut = (0, swr_hooks_1.useSignOut)().signOut;
    var handleSignOut = (0, react_1.useCallback)(function () {
        closeProfileDropdown();
        signOut();
    }, [signOut, closeProfileDropdown]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.profileDropDownContent },
        react_1.default.createElement("ul", { className: styles_module_scss_1.default.profileMenu },
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/wallet/balance") },
                    react_1.default.createElement("img", { src: "/img/profileSidebar/wallet.svg", alt: "wallet" }),
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.hover, src: "/img/profileSidebar/wallet-hover.svg", alt: "wallet" }),
                    t('wallet'))),
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/history/bets") },
                    react_1.default.createElement("img", { src: "/img/profileSidebar/bets.svg", alt: "bonuses" }),
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.hover, src: "/img/profileSidebar/bets-hover.svg", alt: "bonuses" }),
                    t('history'))),
            (config === null || config === void 0 ? void 0 : config.enabledInviteFriends) ? (react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: function (e) {
                    e.preventDefault();
                    closeProfileDropdown();
                    openReferralWidget();
                } },
                react_1.default.createElement(link_1.default, { href: "#" },
                    react_1.default.createElement("img", { src: "/img/profileSidebar/invite.svg", alt: "bets" }),
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.hover, src: "/img/profileSidebar/invite-hover.svg", alt: "bets" }),
                    t('inviteFriends')))) : null,
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/bonuses/").concat((_b = config.headerDropdownBonusesPath) !== null && _b !== void 0 ? _b : 'cash') },
                    react_1.default.createElement("img", { src: "/img/profileSidebar/bonuses.svg", alt: "bets" }),
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.hover, src: "/img/profileSidebar/bonuses-hover.svg", alt: "bets" }),
                    t('bonuses'))),
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: closeProfileDropdown },
                react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/account/profile/general") },
                    react_1.default.createElement("img", { src: "/img/profileSidebar/profile.svg", alt: "profile" }),
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.hover, src: "/img/profileSidebar/profile-hover.svg", alt: "profile" }),
                    t('profile'))),
            react_1.default.createElement("li", { className: styles_module_scss_1.default.profileMenuItem, onClick: handleSignOut },
                react_1.default.createElement("a", null,
                    react_1.default.createElement("img", { src: "/img/profileSidebar/signOut.svg", alt: "signout" }),
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.hover, src: "/img/profileSidebar/signOut-hover.svg", alt: "signout" }),
                    t('signOut'))))));
};
exports.default = Dropdown;
